export function apiURL() {
    return process.env.VUE_APP_ROOT_API
}
export function teste (){}